import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql, compose } from 'react-apollo';
import { Spin, Form, Input, Checkbox, DatePicker, Select, InputNumber, Button, message, Upload } from 'antd';
import validationRegex from '../../utils/validationRegex';

import QUERIES from '../../graphql/queries/customerCreateQueries.graphql';
import MUTATION from '../../graphql/mutations/storeCustomerMutation.graphql';
import STORE_QUERY from '../../graphql/queries/getAllCustomersQuery.graphql';

const FormItem = Form.Item;
const Option = Select.Option;

const formItemLayout = {
  labelCol: {
    xs: { span: 4 },
  },
  wrapperCol: {
    xs: { span: 6 },
  },
};

const submitBtnLayout = {
  wrapperCol: {
    xs: {
      offset: 2,
    },
  },
};

class CustomerCreate extends Component {
  state = {
    submittingForm: false,
  };

  handleSubmit = (event) => {
    this.setState({
      submittingForm: true,
    });
    event.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.props.mutate({
          variables: { ...values },
          update: (proxy, { data: { storeCustomer } }) => {
            const data = proxy.readQuery({ query: STORE_QUERY });
            data.customers.push(storeCustomer);
            proxy.writeQuery({ query: STORE_QUERY, data });
          },
        })
          .then(() => {
            message.success('New customer added!');
            this.props.history.goBack();
          })
          .catch((mutateErr) => {
            console.log(mutateErr);
            this.setState({
              submittingForm: false,
            });
            message.error(mutateErr.message);
          });
      } else {
        console.log(err);
        this.setState({
          submittingForm: false,
        });
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { loading, sectors, constitutions } = this.props.data;
    if (loading) {
      return (
        <Spin size="large" />
      );
    }
    return (
      <div className="container-fluid">
        <h2>Create new customer</h2>
        <div className="ec-content-box">
          <Form onSubmit={this.handleSubmit}>
            <FormItem
              hasFeedback
              label="Customer Name"
              {...formItemLayout}
            >
              {
                getFieldDecorator(
                  'name',
                  {
                    rules: [
                      {
                        required: true,
                        type: 'string',
                        message: 'Name is required!',
                      },
                    ],
                  },
                )(<Input />)
              }
            </FormItem>
            <FormItem
              hasFeedback
              label="Constitution"
              {...formItemLayout}
            >
              {
                getFieldDecorator(
                  'constitution_id',
                  {
                    rules: [
                      {
                        required: true,
                        message: 'Constitution is required!',
                      },
                    ],
                  },
                )(<Select placeholder="Select one">{ constitutions.map((constitution) => (<Option value={constitution.id} key={constitution.id}>{constitution.name}</Option>)) }</Select>)
              }
            </FormItem>
            <FormItem
              hasFeedback
              label="Sector"
              {...formItemLayout}
            >
              {
                getFieldDecorator(
                  'sector_id',
                  {
                    rules: [
                      {
                        required: true,
                        message: 'Sector is required!',
                      },
                    ],
                  },
                )(<Select placeholder="Select one">{ sectors.map((sector) => (<Option value={sector.id} key={sector.id}>{sector.name}</Option>)) }</Select>)
              }
            </FormItem>
            <FormItem
              hasFeedback
              label="Sub Sector"
              {...formItemLayout}
            >
              {
                getFieldDecorator(
                  'sub_sector',
                  {
                    rules: [
                      {
                        type: 'string',
                        message: 'Incorrect value entered!',
                      },
                    ],
                  },
                )(<Input />)
              }
            </FormItem>
            <FormItem
              hasFeedback
              label="Line of activity"
              {...formItemLayout}
            >
              {
                getFieldDecorator(
                  'line_of_activity',
                  {
                    rules: [
                      {
                        type: 'string',
                        message: 'Incorrect value entered!',
                      },
                    ],
                  },
                )(<Input />)
              }
            </FormItem>
            <FormItem
              hasFeedback
              label="Landline no."
              {...formItemLayout}
            >
              {
                getFieldDecorator(
                  'landline',
                  {
                    rules: [
                      {
                        pattern: validationRegex.landline,
                        message: 'Incorrect value entered!',
                      },
                    ],
                  },
                )(<Input placeholder="With STD code & start with 0" />)
              }
            </FormItem>
            <FormItem
              hasFeedback
              label="Email address"
              {...formItemLayout}
            >
              {
                getFieldDecorator(
                  'email',
                  {
                    rules: [
                      {
                        type: 'email',
                        message: 'Incorrect email entered!',
                      },
                    ],
                  },
                )(<Input />)
              }
            </FormItem>
            <FormItem
              label="Website"
              hasFeedback
              {...formItemLayout}
            >
              {
                getFieldDecorator(
                  'website',
                  {
                    rules: [
                      {
                        type: 'url',
                        message: 'Incorrect website entered!',
                      },
                    ],
                  },
                )(<Input placeholder="Format: http://bizminder.co.in" />)
              }
            </FormItem>
            <FormItem {...submitBtnLayout}>
              <Button type="primary" htmlType="submit" loading={this.state.submittingForm}>Submit</Button>
            </FormItem>
          </Form>
        </div>
      </div>
    );
  }
}

CustomerCreate.propTypes = {
  data: PropTypes.shape({
    constitutions: PropTypes.array,
    sectors: PropTypes.array,
    loading: PropTypes.bool.isRequired,
  }).isRequired,
  history: PropTypes.shape({
    goBack: PropTypes.func.isRequired,
  }).isRequired,
  mutate: PropTypes.func.isRequired,
  form: PropTypes.shape({
    getFieldDecorator: PropTypes.func,
    validateFieldsAndScroll: PropTypes.func,
    resetFields: PropTypes.func,
  }).isRequired,
};

export default compose(
  graphql(QUERIES),
  graphql(MUTATION),
  Form.create(),
)(CustomerCreate);



// WEBPACK FOOTER //
// ./src/pages/customer/CustomerCreate.jsx